import { t } from "@lingui/macro";
import WifiNetworks from "./WifiNetworks";
import { GlobalHeader } from "@WahooFitness/wahoo-offline-mfe";
import { Container } from "@mui/material";

const WifiConfig = ({ appToken }: { appToken: string }) => {
  return (
    <>
      <GlobalHeader title={t`Wi-Fi`} />
      <Container maxWidth="sm" disableGutters sx={{ minHeight: "100%" }}>
        <WifiNetworks appToken={appToken} />
      </Container>
    </>
  );
};

export default WifiConfig;
